(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["table-selector"] && !Shopify.designMode) return;
  try {
    
  /* Tri par prix de la grille mobile du sélecteur de tables. Les cartes sont
     réellement déplacées dans le DOM : l'ordre de tabulation et de lecture suit
     l'ordre affiché. La tuile WhatsApp reste en dernière case. */
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ts-sort]');
    if (!button) return;

    const grid = button.closest('.tselector')?.querySelector('.tselector__grid');
    if (!grid) return;

    const next = button.dataset.tsSort === 'asc' ? 'desc' : 'asc';
    const direction = next === 'asc' ? 1 : -1;
    const cards = [...grid.querySelectorAll('.tselector__card[data-price]')];
    cards.sort((a, b) => (Number(a.dataset.price) - Number(b.dataset.price)) * direction);

    const tail = grid.querySelector('.tselector__wa');
    for (const card of cards) grid.insertBefore(card, tail);

    const label = next === 'asc' ? 'croissant' : 'décroissant';
    button.dataset.tsSort = next;

    const state = button.querySelector('[data-ts-sort-state]');
    if (state) state.textContent = label;

    const arrow = button.querySelector('[data-ts-sort-arrow]');
    if (arrow) arrow.textContent = next === 'asc' ? '↑' : '↓';

    const live = button.parentElement.querySelector('[data-ts-sort-live]');
    if (live) live.textContent = `Tables triées par prix ${label}.`;
  });

  } catch(e) { console.error(e); }
})();
})();
